import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { CountriesService } from 'src/app/global/countries-list';
import { Country } from 'src/app/models/country.model';
import { AlertService } from 'src/app/service/alert.service';
import { NewUserRequest, SignupService } from '../../service/http-services/signup-service.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  form: FormGroup;
  registerLoading: boolean = false;
  countries: Country[] = []
  registerSuccess: boolean = false;
  emailSuccess: string = ""


  constructor(
    public fb: FormBuilder,
    private signupService: SignupService,
    private countriesService: CountriesService,
    private alertService: AlertService
  ) {
    this.form = fb.group({
      emailFormEx: [null, [Validators.required, Validators.email]],
      name: [null, [Validators.required, Validators.pattern('^[a-zA-Z]*$')]],
      password: [null, [Validators.required, Validators.minLength(8)]],
      country: ["", Validators.required],
      policy: [null, Validators.requiredTrue]
    })
  }

  ngOnInit(): void {
    this.countries = this.countriesService.getCountries();
  }

  get signupForm() { return this.form.controls; }

  createUser() {
    this.registerLoading = true;
    let signupReq: NewUserRequest = {
      email: this.signupForm.emailFormEx.value,
      name: this.signupForm.name.value,
      password: this.signupForm.password.value,
      country: this.signupForm.country.value
    }
    this.emailSuccess = this.signupForm.emailFormEx.value;
    this.signupService.signup(signupReq).pipe(
      finalize(() => this.registerLoading = false)
    )
      .subscribe(
        () => {
          this.registerSuccess = true;
        },
        error => {
          this.alertService.error(error.error.message)
          this.emailFormEx!.setErrors({notUnique: true})
        }
      )
  }

  get emailFormEx() { return this.form.get('emailFormEx'); }
  get nameForm() { return this.form.get('name') }
  get passwordForm() { return this.form.get('password') }

}
